import { render } from "./change-address.vue?vue&type=template&id=574fc27c"
import script from "./change-address.vue?vue&type=script&lang=js"
export * from "./change-address.vue?vue&type=script&lang=js"

import "./change-address.vue?vue&type=style&index=0&id=574fc27c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__